var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "rotate(0.5turn)"
    },
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "#cf2c47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 6.09521L7.97656 10.4702C7.8125 10.6343 7.59375 10.7163 7.375 10.7163C7.12891 10.7163 6.91016 10.6343 6.74609 10.4702C6.39062 10.1421 6.39062 9.56787 6.74609 9.23975L9.61719 6.34131H1.25C0.757812 6.34131 0.375 5.9585 0.375 5.46631C0.375 5.00146 0.757812 4.59131 1.25 4.59131H9.61719L6.74609 1.72021C6.39062 1.39209 6.39062 0.817871 6.74609 0.489746C7.07422 0.134277 7.64844 0.134277 7.97656 0.489746L12.3516 4.86475C12.707 5.19287 12.707 5.76709 12.3516 6.09521Z",
    fill: "#cf2c47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.930e8d99e0b7f3bb737e33b5d857c0a5.svg";
export { ForwardRef as ReactComponent };